import { Box, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
interface Title {
  title: string;
  sentTx?: string;
  receivedTx?: string;
}

const MoreInfo = (data: Title) => {
  return (
    <Grid item xl={4} sm={12} xs={12}>
      <Box className="card group h-100 shadow-sm rounded">
        <Box className="card-body bg-white ">
          <Box className="d-flex justify-content-between align-items-center mb-5">
            <span className="fs-6 mb-0 fw-bold">{data.title}</span>
          </Box>
          <Box>
            <Typography className="text-cap">Last Txn Sent</Typography>
            {data.sentTx ? (
              <Link to={`/tx/${data.sentTx}`}>
                {data.sentTx.substring(0, 18)}...
              </Link>
            ) : (
              <span>No transactions sent</span>
            )}
          </Box>
          <Box className="mt-2">
            <Typography className="text-cap">First Txn Sent</Typography>
            {data.receivedTx ? (
              <Link to={`/tx/${data.receivedTx}`}>
                {data.receivedTx.substring(0, 18)}...
              </Link>
            ) : (
              <span>No transactions sent</span>
            )}
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default MoreInfo;
